<template>
  <div class="text-center">
    <picture>
      <source media="(max-width: 1199px)" srcset="@/assets/images/Reem/mobileCelebration.png">
      <img src="@/assets/images/Reem/protected.svg" alt="step image">
    </picture>
    <h3 class="title">You rock! 💪</h3>
    <div class="sub-title">Your campaigns are already protected from click fraud</div>
    <a :href="dashboard_link">Go to dashboard</a>
  </div>
</template>

<script>
import { AppConfig } from '@/config';

export default {
  name: "AccountProtected",
  data() {
    return {
      dashboard_link: `${AppConfig.siteUrl}/dashboard`
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";
@import "src/assets/style/responsive";

.title, .sub-title {
  margin-left: auto;
  margin-right: auto;
}
a {
  display: inline-block;
  padding: 16px 32px;
  background: $orange;
  color: $white;
  border: none;
  border-radius: 50px;
  font-family: "Sofia Pro Light";
  font-size: 18px;
  margin-top: 48px;
  margin-bottom: 54px;
}
img {
  @include mobile {
    width: 100%;
  }
}
.sub-title {
  @include mobile {
    max-width: 250px;
  }
  @include desktop {
    max-width: 372px;
  }
}
</style>